import api from "./Api";

class CustoService {
  GetCusto(payload) {
    return api.get("/v1/custo/" + payload).then((response) => {
      return response.data;
    });
  }

  GetAllCusto() {
    return api.get("/v1/custo").then((response) => {
      return response.data;
    });
  }

  PostCusto(payload) {
    return api.post("/v1/custo/", payload).then((response) => {
      return response.data;
    });
  }

  PutCusto(payload) {
    return api.put("/v1/custo/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteCusto(payload) {
    return api.delete("/v1/custo/" + payload).then((response) => {
      return response.data;
    });
  }

  GetCustoOData(payload) {
    return api.get("/OData/Custo" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new CustoService();
